import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { APP_CONFIG, AppConfig } from 'src/app.config';
import { RoutePageComponent } from '../shared/route-page/route-page.component';
import { Router, ActivatedRoute } from '@angular/router';
import { OktaWidgetComponent } from '../okta-widget/okta-widget.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-login',
    imports: [OktaWidgetComponent, RoutePageComponent, MatIconModule],
    templateUrl: './login.component.html',
    styles: [],
    encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
    // authService;

    constructor() // @Inject(OKTA_AUTH) oktaAuth: OktaAuth, // @Inject(APP_CONFIG) private config: AppConfig,
    // private router: Router,
    // private route: ActivatedRoute
    {
        // this.authService = oktaAuth;
    }

    ngOnInit() {
        // Clear URL parameters for login page
        // this.router.navigate(['/login'], { replaceUrl: true });
        // if (!this.config.appURL.includes('localhost')) {
        //     const attemptedUrl = this.authService.getOriginalUri();
        //     const encodedReturnUrl = encodeURIComponent(attemptedUrl);
        //     window.open(`${this.config.launcherURL}?returnUrl=${encodedReturnUrl}`, '_self');
        // }
    }
}
